export const SET_CONTENTS = 'cms/contents/set-contents';
export const SET_QUICK_FILTER = 'cms/contents/set-quick-filter';
export const SET_CONTENT_CATEGORY_FILTER = 'cms/contents/set-content-categorყ-filter';
export const CHECK_STATUS = 'cms/contents/check-status';
export const CHECK_ACCESS = 'cms/contents/check-access';
export const CHECK_AUTHOR = 'cms/contents/check-author';
export const SET_CURRENT_AUTHOR_SHOW = 'cms/contents/set-current-author-show';
export const SET_CURRENT_STATUS_SHOW = 'cms/contents/set-current-status-show';
export const SET_SORT = 'cms/contents/set-sort';
export const SET_CONTENT_TYPE = 'cms/contents/set-content-type';
export const SET_GROUP = 'cms/contents/set-group';
export const SELECT_ROW = 'cms/contents/select-row';
export const SELECT_ROWS = 'cms/contents/select-rows';
export const SELECT_SINGLE_ROW = 'cms/contents/select-single-row';
export const SELECT_ALL_ROWS = 'cms/contents/select-all-rows';
export const SET_JOIN_CONTENT_CATEGORY = 'cms/contents/set-join-content-category';
export const RESET_JOIN_CONTENT_CATEGORIES = 'cms/contents/reset-join-content-categories';
export const SET_TAB_SEARCH = 'cms/contents/set-tab-search';
export const RESET_AUTHOR_STATUS = 'cms/contents/reset-author-status';
export const CLEAR_CONTENTS_STATE = 'cms/contents/clear-content-state';
export const SET_CONTENTS_STATUS = 'cms/contents/set-contents-status';
